module.exports = __webpack_public_path__ + "static/media/newbalance.7d719547.jpg";